import classnames from 'classnames';
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import styles from "./HeadingSection.module.scss";
import { Text } from "../../Text/Text/Text";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeadingSection = function HeadingSection(_ref) {
  var heading = _ref.heading,
    subHeading = _ref.subHeading,
    options = _ref.options;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.headingContainer,
    children: [heading && /*#__PURE__*/_jsx(HeadingText, {
      richText: true,
      align: "left",
      className: classnames(styles.heading, {
        [styles.bigHeading]: !!(options !== null && options !== void 0 && options.bigHeading)
      }),
      typog: heading.typog,
      children: heading.text
    }), subHeading && /*#__PURE__*/_jsx(Text, {
      richText: true,
      align: "left",
      className: classnames(styles.subheading, {
        [styles.longSubheading]: !!(options !== null && options !== void 0 && options.longSubheading)
      }),
      typog: subHeading.typog,
      children: subHeading.text
    })]
  });
};